module.exports = "\r\n  .column {\r\n    max-width: 450px;\r\n    margin-top: 8%;\r\n  }\r\n  .status {\r\n    color: red;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/Components/login/login.component.css
// module id = ./src/app/Components/login/login.component.css
// module chunks = main